import React, { useState } from 'react';
import { back, chevron_right, gear } from '../../Images/Icons';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import { View } from '../../Components';
import css from  './ServicesPage.module.scss'; 
import Accordion from '../../Components/Accordion';


const UserGuidePage = () => {
    const navigation = useNavigate();
    const [state, setAllState] = useState({ });

    const setState = data => {
        setAllState(prevState => ({ ...prevState, ...data }));
    }

    const onGoback = () => { 
        navigation(-1);
    } 

    return (
        <div>
            <div className="mainHeader" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', }}>
                <div style={{ display: 'flex', margin: '0 20px' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12 }}>User Guide</div>
                </div>
            </div>
            <div className="page-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flex: 1, background: '#F2F5FA' }}>
                <div style={{ margin: 20, marginTop: 24 }}> 
                    {
                        USER_GUIDE.map((item, i) => (<Accordion key={`key-${i}`} style={{marginTop: 12}} title={item.title} content={parse(item.content)} />))
                    }
                    
                </div>
            </div>
        </div>
    )
}

export default UserGuidePage;

const USER_GUIDE = [
    {
        title: 'What is MODENA Energy monitoring website? ',
        content: 'It is a website aiming to process the tracking and analyze the performance of solar photovoltaic (PV) systems in real-time. This involves gathering data such as energy production, system health, and environmental conditions to optimize performance and troubleshoot issues.'
    },
    {
        title: 'What are the benefits of using the monitoring website?',
        content: `The app allows you to:
        <ul>
            <li>Track your system's performance in real-time and identify any potential issues early on.</li>
            <li>Monitor historical data to understand energy production trends and optimize energy usage.</li>
            <li>Estimate your cost savings on electricity bills based on solar energy production.</li>
            <li>Receive alerts for system errors or performance issues, allowing for proactive maintenance.</li>
        </ul>`
    },
    {
        title: 'What kind of data can I expect to see on the monitoring website?',
        content: 'You can expect to see real-time data on energy production, including kilowatt-hours (kWp) generated, system voltage, current, and power output. Additionally, you may see historical data, environmental conditions like temperature and sunlight intensity, and alerts for system faults or malfunctions. '
    },
    {
        title: 'How to login?',
        content: 'To login to the MODENA Energy monitoring website, visit the login page and enter your username/email and password in the designated fields. Then, click the "Login" button to access your account dashboard.'
    },
    {
        title: 'How If I forgot my password?',
        content: `To reset your password, visit MODENA Energy monitoring website's login page, click on the "Forgot Password?" option, enter your email or username, follow the instructions in the password reset email, create a new password, and then log in using your newly reset password.`
    },
    {
        title: 'How to read the main dashboard page?',
        content: 'The main dashboard page provides an overview of key system metrics and performance indicators at a glance. This may include real-time energy production, system status, alerts or notifications, weather conditions, and other relevant information. Each metric is usually displayed visually using charts, graphs, or numerical values for easy interpretation.'
    },
    {
        title: 'How often is the data updated?',
        content: 'The data is updated in real-time.'
    },
    {
        title: 'Can I access the monitoring website from any device?',
        content: 'Yes, MODENA Energy monitoring website is accessible from any internet-enabled device, including computers, smartphones, and tablets.'
    },
    {
        title: 'Is the monitoring website secure?',
        content: 'Yes, security is a priority for MODENA Energy monitoring website. MODENA Energy monitoring website uses encryption and other security measures to protect user data and ensure privacy.'
    },
    {
        title: 'What happens if there\'s a problem with my solar panel system?',
        content: 'If a problem is detected, MODENA Energy monitoring website will alert you via email or notification. You can contact the MODENA Energy team for assistance.'
    }
];